/* ==========================================
   MK CUSTOM PDP CURSOR
   ========================================== */

document.addEventListener('DOMContentLoaded', function () {
  const pdp = document.querySelector('.mkcustom-pdp-layout');

  if (!pdp) return;

  const defaultCursor = pdp.dataset.customCursor;
  const addToCartCursor = pdp.dataset.customCursorAddToCart;

  if (!defaultCursor) return;


  /* ==========================================
     PRELOAD CURSOR IMAGES
     ========================================== */

  const preloadDefaultCursor = new Image();
  preloadDefaultCursor.src = defaultCursor;

  if (addToCartCursor) {
    const preloadAddToCartCursor = new Image();
    preloadAddToCartCursor.src = addToCartCursor;
  }


  /* ==========================================
     SHARED ADD TO CART / PREORDER SELECTORS
     ========================================== */

  const addToCartSelector = [
    'button[name="add"]',
    '[type="submit"][name="add"]',
    '#pp-cleanslate-anchor',
    '#pp-cleanslate1-anchor'
  ].join(',');


  /* ==========================================
     DESKTOP - NORMAL CLICK RIPPLE
     ========================================== */

  document.addEventListener(
    'pointerdown',
    function (event) {
      const isDesktop =
        window.matchMedia('(min-width: 1101px)').matches;

      if (!isDesktop) return;
      if (event.pointerType === 'touch') return;

      const isAddToCart = event.target.closest(
        addToCartSelector
      );

      if (isAddToCart) return;

      const ripple = document.createElement('span');

      ripple.className = 'mkcustom-pdp-click-ripple';
      ripple.style.left = event.clientX + 'px';
      ripple.style.top = (event.clientY - 6) + 'px';

      document.body.appendChild(ripple);

      ripple.addEventListener(
        'animationend',
        function () {
          ripple.remove();
        },
        { once: true }
      );
    },
    true
  );


  /* ==========================================
     DESKTOP - ADD TO CART / PREORDER EFFECT
     ========================================== */

  document.addEventListener(
    'pointerdown',
    function (event) {
      const isDesktop =
        window.matchMedia('(min-width: 1101px)').matches;

      if (!isDesktop) return;
      if (event.pointerType === 'touch') return;

      const addToCartButton = event.target.closest(
        addToCartSelector
      );

      if (!addToCartButton) return;


      /* Desktop activation ring */
      const effect = document.createElement('span');

      effect.className = 'mkcustom-pdp-add-effect';
      effect.style.left = event.clientX + 'px';
      effect.style.top = (event.clientY - 6) + 'px';

      document.body.appendChild(effect);

      effect.addEventListener(
        'animationend',
        function () {
          effect.remove();
        },
        { once: true }
      );


      /* Desktop shaking / glowing Pokeball */
      if (!addToCartCursor) return;

      document.documentElement.classList.add(
        'mkcustom-cart-cursor-active'
      );

      const cartCursor = document.createElement('span');

      cartCursor.className = 'mkcustom-pdp-cart-cursor';
      cartCursor.style.left = event.clientX + 'px';
      cartCursor.style.top = (event.clientY - 6) + 'px';

      const cartCursorImage = document.createElement('img');

      cartCursorImage.src = addToCartCursor;
      cartCursorImage.alt = '';

      cartCursor.appendChild(cartCursorImage);
      document.body.appendChild(cartCursor);

      cartCursorImage.addEventListener(
        'animationend',
        function () {
          cartCursor.remove();

          document.documentElement.classList.remove(
            'mkcustom-cart-cursor-active'
          );
        },
        { once: true }
      );
    },
    true
  );


  /* ==========================================
     MOBILE / TABLET - ADD TO CART / PREORDER
     CAPTURE ANIMATION
     ========================================== */

  document.addEventListener(
    'pointerdown',
    function (event) {
      const isTouchExperience =
        window.matchMedia('(max-width: 1100px)').matches;

      if (!isTouchExperience) return;

      const addToCartButton = event.target.closest(
        addToCartSelector
      );

      if (!addToCartButton) return;

      /*
      * Mobile / tablet animation should only fire
      * from the original PDP button.
      *
      * Ignore PreProduct modal buttons or any
      * duplicate controls rendered outside the PDP.
      */
      if (!addToCartButton.closest('.mkcustom-pdp-layout')) {
        return;
      }
      /*
       * IMPORTANT:
       * We do not preventDefault(), stopPropagation(),
       * or stopImmediatePropagation().
       *
       * PreProduct / Shopify remains free to process
       * the real tap immediately.
       */

      const buttonRect =
        addToCartButton.getBoundingClientRect();

      const captureLeft =
        buttonRect.left + buttonRect.width / 2;

      const captureTop =
        buttonRect.top + buttonRect.height / 2;

      /*
       * Defer only the visual insertion until after
       * the current pointerdown event finishes.
       */
      window.setTimeout(function () {
        const existingCapture = document.querySelector(
          '.mkcustom-pdp-touch-capture'
        );

        if (existingCapture) {
          existingCapture.remove();
        }

        const touchCapture =
          document.createElement('span');

        touchCapture.className =
          'mkcustom-pdp-touch-capture';

        touchCapture.style.left =
          captureLeft + 'px';

        touchCapture.style.top =
          captureTop + 'px';

        const touchCaptureImage =
          document.createElement('img');

        /*
         * Prefer the special Add to Cart image,
         * otherwise fall back to the normal cursor image.
         */
        touchCaptureImage.src =
          addToCartCursor || defaultCursor;

        touchCaptureImage.alt = '';

        touchCapture.appendChild(
          touchCaptureImage
        );

        document.body.appendChild(
          touchCapture
        );

        /*
         * Remove only when the outer mobile/tablet
         * movement animation finishes.
         */
        touchCapture.addEventListener(
          'animationend',
          function (animationEvent) {
            if (
              animationEvent.animationName ===
              'mkcustomTouchBallPath'
            ) {
              touchCapture.remove();
            }
          }
        );
      }, 0);
    },
    true
  );

});